function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// Imports
import Button from '@engine/components/presentational/base/button';

var ExclamationIcon = function ExclamationIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M12 16a1 1 0 1 0 1 1 1 1 0 0 0-1-1zm10.67 1.47l-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53zm-1.73 2a1 1 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02zM12 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"
  }));
};

ExclamationIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import Panel from '@engine/components/presentational/base/panel';
import React from 'react';
import RiskFilterSettingsNewForm from '@engine/components/containers/risk-filter-settings-new-form';
import { connect } from 'react-redux';
import { fetchRiskFilterSettings } from '@engine/actions/creators/risk-filters';

var RiskFilterSettingsProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(RiskFilterSettingsProvider, _React$Component);

  var _super = _createSuper(RiskFilterSettingsProvider);

  function RiskFilterSettingsProvider() {
    _classCallCheck(this, RiskFilterSettingsProvider);

    return _super.apply(this, arguments);
  }

  _createClass(RiskFilterSettingsProvider, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "col-xl-9 col-lg-9 col-md-9 col-sm-9"
      }, this.props.hasError ? React.createElement(Panel.Container, null, React.createElement(Panel.Body, null, React.createElement("div", {
        className: "risk-filters-configuration-settings-error"
      }, React.createElement("span", null, "Oops, something went wrong!"), React.createElement(ExclamationIcon, null), React.createElement("span", null, "".concat(I18n.t('javascript.errors.unable_to_process_request'), "\n                      ").concat(I18n.t('javascript.errors.try_again_later')), React.createElement("br", null), React.createElement(Button, {
        className: "mt-5",
        size: "sm",
        onClick: function onClick() {
          return _this.fetchSettings();
        }
      }, I18n.t('javascript.actions.try_again')))))) : React.createElement(RiskFilterSettingsNewForm, {
        currentSettings: {},
        defaultSettings: this.props.filterSettings.default_settings || [],
        filterClass: this.props.filterClass,
        formUrl: this.props.formUrl,
        redirectUrl: this.props.redirectUrl
      })));
    }
  }, {
    key: "fetchSettings",
    value: function fetchSettings() {
      this.props.fetchRiskFilterSettings(this.props.fetchUrl + this.props.filterClass);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchSettings();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.filterClass !== this.props.filterClass) {
        this.fetchSettings();
      }
    }
  }]);

  return RiskFilterSettingsProvider;
}(React.Component);

export default connect(function (state) {
  return {
    filterSettings: state.riskFilterSettings.settings,
    hasError: state.riskFilterSettings.hasError
  };
}, {
  fetchRiskFilterSettings: fetchRiskFilterSettings
})(RiskFilterSettingsProvider);